(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["klaviyo-deferred-loader"] && !Shopify.designMode) return;
  try {
    (() => {
  const source = 'https://static.klaviyo.com/onsite/js/VrTBte/klaviyo.js?company_id=VrTBte';
  const selector = 'script[src*="static.klaviyo.com/onsite/js/VrTBte/klaviyo.js"]';
  const passiveEvents = ['scroll', 'pointerdown', 'touchstart'];
  let started = false;
  let fallbackTimer;

  const removeTriggers = () => {
    passiveEvents.forEach((eventName) => {
      window.removeEventListener(eventName, loadKlaviyo);
    });
    window.removeEventListener('keydown', loadKlaviyo);
    window.clearTimeout(fallbackTimer);
  };

  function loadKlaviyo() {
    if (started) return;

    started = true;
    removeTriggers();

    if (document.querySelector(selector)) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = source;
    document.head.appendChild(script);
  }

  passiveEvents.forEach((eventName) => {
    window.addEventListener(eventName, loadKlaviyo, { once: true, passive: true });
  });
  window.addEventListener('keydown', loadKlaviyo, { once: true });

  const scheduleFallback = () => {
    fallbackTimer = window.setTimeout(loadKlaviyo, 8000);
  };

  if (document.readyState === 'complete') {
    scheduleFallback();
  } else {
    window.addEventListener('load', scheduleFallback, { once: true });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-country-data"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.atelierCountrySelectorInitialized) return;

  window.atelierCountrySelectorInitialized = true;

  const hydrateCountryList = (toggle) => {
    const popoverId = toggle.getAttribute('aria-controls');
    const popover = popoverId ? document.getElementById(popoverId) : null;
    const listbox = popover?.querySelector('[data-country-listbox]');

    if (!listbox || listbox.dataset.hydrated === 'true') return;

    const dataElement = document.getElementById('localization-country-options-data');

    if (!dataElement) return;

    const countries = JSON.parse(dataElement.textContent);
    const fragment = document.createDocumentFragment();
    let selectedOptionId = '';

    countries.forEach((country) => {
      const option = document.createElement('button');
      const label = document.createElement('span');

      option.type = 'submit';
      option.name = 'country_code';
      option.className = 'popover__value-option';
      option.setAttribute('role', 'option');
      option.value = country.isoCode;
      option.id = `country-option-${listbox.id}-${country.isoCode}`;
      option.setAttribute('aria-selected', country.selected ? 'true' : 'false');
      label.textContent = country.label;
      option.appendChild(label);
      fragment.appendChild(option);

      if (country.selected) selectedOptionId = option.id;
    });

    listbox.appendChild(fragment);
    listbox.dataset.hydrated = 'true';

    if (selectedOptionId) {
      listbox.setAttribute('aria-activedescendant', selectedOptionId);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const toggle = target?.closest('[data-country-localization-toggle]');

      if (toggle) hydrateCountryList(toggle);
    },
    true
  );
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["loox-deferred-loader"] && !Shopify.designMode) return;
  try {
    (() => {
  const marker = document.getElementById('loox-deferred-loader');

  if (!marker) return;

  const source = marker.dataset.source;
  const pageType = marker.dataset.pageType;
  const targets = new Set(
    document.querySelectorAll('.loox-rating, .loox-reviews-default, .shopify-section--testimonials')
  );
  const reviewWidgets = document.querySelectorAll('.loox-widget, #looxReviews');
  let started = false;

  if (pageType === 'index') {
    const revealChat = () => {
      const revealOffset = Math.max(240, window.innerHeight * 0.65);

      if (window.scrollY < revealOffset) return;

      marker.dataset.chatReady = 'true';
      window.removeEventListener('scroll', revealChat);
    };

    revealChat();
    window.addEventListener('scroll', revealChat, { passive: true });
  }

  reviewWidgets.forEach((widget) => {
    targets.add(widget.closest('.shopify-section') || widget);
  });

  const addAggregateRating = () => {
    const ratingElement = document.querySelector('.loox-rating[data-rating][data-raters]');

    if (!ratingElement) return;

    const ratingValue = Number.parseFloat(ratingElement.dataset.rating);
    const reviewCount = Number.parseInt(ratingElement.dataset.raters, 10);

    if (!Number.isFinite(ratingValue) || !Number.isFinite(reviewCount) || reviewCount < 1) return;

    const applyRating = (value) => {
      if (!value || typeof value !== 'object') return false;

      if (Array.isArray(value)) {
        return value.some(applyRating);
      }

      const types = Array.isArray(value['@type']) ? value['@type'] : [value['@type']];

      if (types.includes('Product') || types.includes('ProductGroup')) {
        if (!value.aggregateRating) {
          value.aggregateRating = {
            '@type': 'AggregateRating',
            ratingValue,
            reviewCount
          };
        }

        return true;
      }

      if (value['@graph']) {
        return applyRating(value['@graph']);
      }

      return false;
    };

    document.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
      try {
        const data = JSON.parse(script.textContent);

        if (applyRating(data)) {
          script.textContent = JSON.stringify(data);
        }
      } catch {
        return;
      }
    });
  };

  const loadLoox = () => {
    if (started || document.querySelector('script[src*="loox.io/widget/"]')) return;

    started = true;
    window.loox_global_hash = marker.dataset.globalHash;
    window.loox_bundle_reviews_enabled = false;
    window.loox_pop_active = false;
    window.loox_pop_display = {
      home_page: false,
      product_page: false,
      cart_page: false,
      other_pages: false
    };

    const script = document.createElement('script');
    script.async = true;
    script.src = source;
    document.head.appendChild(script);
  };

  addAggregateRating();

  const productRating = document.querySelector('.loox-rating');

  if (productRating) {
    ['pointerenter', 'focusin', 'click'].forEach((eventName) => {
      productRating.addEventListener(eventName, loadLoox, { once: true });
    });
  }

  if (targets.size === 0) return;

  if (!('IntersectionObserver' in window)) {
    loadLoox();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;

      observer.disconnect();
      loadLoox();
    },
    { rootMargin: '1200px 0px' }
  );

  targets.forEach((target) => observer.observe(target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
  const hydrateImage = (image) => {
    if (!image) return;

    if (image.dataset.productDeferredSrcset) {
      image.srcset = image.dataset.productDeferredSrcset;
      image.removeAttribute('data-product-deferred-srcset');
    }

    if (image.dataset.productDeferredSrc) {
      image.src = image.dataset.productDeferredSrc;
      image.removeAttribute('data-product-deferred-src');
    }
  };

  const hydrateSecondaryImage = (event) => {
    const card = event.target.closest('product-card');

    if (!card) return;

    hydrateImage(card.querySelector('.product-card__image--secondary'));
  };

  const primaryImages = document.querySelectorAll(
    '.product-card__image--primary[data-product-deferred-src], .product-card__image--primary[data-product-deferred-srcset]'
  );

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          hydrateImage(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '400px 0px' }
    );

    primaryImages.forEach((image) => observer.observe(image));
  } else {
    primaryImages.forEach(hydrateImage);
  }

  document.addEventListener('pointerover', hydrateSecondaryImage, { passive: true });
  document.addEventListener('focusin', hydrateSecondaryImage);
  document.addEventListener('touchstart', hydrateSecondaryImage, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

})();
